import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { ReportsServicesService } from '../../services/reports-services.service';

@Component({
    selector: 'app-ticket',
    imports: [CommonModule],
    templateUrl: './ticket.component.html',
    styleUrl: './ticket.component.scss'
})
export class TicketComponent {
  @Input() data:any;
  @Input() clientId!:number;
  signature="";

  constructor(private service:ReportsServicesService){
    
  }

  ngOnInit(){
    this.getSignature();
  }


  getSignature(){
    this.service.getConsumptionSignature(this.clientId,this.data.secuence).subscribe({
      next:(resp:any)=>{
        this.signature=resp;
      },
      error:(err:any)=>{
        this.signature='';
      }
    })
  }

}
